import { render, staticRenderFns } from "./downFile.vue?vue&type=template&id=28e3bb68&scoped=true&"
import script from "./downFile.vue?vue&type=script&lang=js&"
export * from "./downFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e3bb68",
  null
  
)

export default component.exports